"use client"

import { type ComponentProps } from "react"
import { useRouter } from "next/navigation"
import { clsx } from "clsx"

import SquareCta, { type SquareCtaVariants } from "~/components/ui/SquareCta"
import Icon from "~/components/abstracts/Icon"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { usePageHistory } from "~/managers/PageHistoryManager"

import { sprinkles, type Sprinkles } from "~/styles/sprinkles.css"
import { text } from "~/styles/variants"

import * as css from "./styles.css"

type BackCtaProps = ComponentProps<"button"> & {
  sprinklesCss?: Sprinkles
  position?: Sprinkles["position"]
  isCollectionPage?: boolean
} & SquareCtaVariants

export default function BackCta({
  className,
  sprinklesCss,
  isCollectionPage,
  position = "absolute",
  theme = "borderGrey",
}: BackCtaProps) {
  const t = useTranslate()
  const router = useRouter()
  const { history } = usePageHistory()
  // TODO : Change the "-3" when will find why the history add paths twice
  const previousPathname = history?.[history?.length - 3]?.pathname

  return previousPathname ? (
    <SquareCta
      data-comp="UI/BackCta"
      className={clsx(
        css.backBtn,
        text({ design: "neue-10", textTransform: "uppercase" }),
        className,
        sprinkles({
          display: "flex",
          position,
          alignItems: "center",
          justifyContent: "center",
          ...sprinklesCss,
        })
      )}
      overrideTextPresets
      onClick={isCollectionPage && previousPathname ? () => router.push(previousPathname) : () => router.back()}
      size="backButton"
      theme={theme}
    >
      <Icon className={css.icon} sprinklesCss={{ marginRight: 5 }} name={"Arrow"} width={12.5} theme={"grey-tundora"} />
      {t("navigation_back_button")}
    </SquareCta>
  ) : null
}
